// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1rjcn","header":"ReportDetails_header__1Nd2R","title":"ReportDetails_title__3gCnn","left":"ReportDetails_left__1Jy4S"};